import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GroupListRoutingModule } from './group-list-routing.module';
import { GroupListComponent } from './group-list.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgSelectModule } from '@ng-select/ng-select';


@NgModule({
  declarations: [GroupListComponent],
  imports: [
    CommonModule,
    NgbModule,
    ModalModule.forRoot(),
    FormsModule,ReactiveFormsModule,
    NgSelectModule,
    GroupListRoutingModule
  ]
})
export class GroupListModule { }
